import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import i18n, { detectLanguage, setLanguage, toAppLanguage } from '@/i18n'
import { getAppParams, initAppParams, setAppParams } from '@/stores/app'
import { initRNListener, installRouterBridge } from '@/bridge'

import 'vant/lib/index.css'
import './styles/vant.css'
import './index.css'

const app = createApp(App)
app.use(router)
app.use(i18n)

// 全局错误兜底（async / 事件处理器错误，onErrorCaptured 不覆盖这些）
app.config.errorHandler = (err) => {
  console.error('[app errorHandler]', err)
}

// ---- 应用初始化 ----
async function bootstrap() {
  // RN 注入优先，旧版 URL query 补缺；语言就绪后再渲染，避免首屏短暂显示错误语言。
  initAppParams()
  const activeLanguage = await setLanguage(detectLanguage(getAppParams().language))
  setAppParams({ language: toAppLanguage(activeLanguage) })

  initRNListener()
  installRouterBridge(router)
  app.mount('#app')
}

void bootstrap()
